// extracted by mini-css-extract-plugin
export default {"popUp":"UserPopUp_popUp__u1ma-","imageContainer":"UserPopUp_imageContainer__Y+zYN","iconContainer":"UserPopUp_iconContainer__qolLm"};